// extracted by mini-css-extract-plugin
export default {"root":"lAulP","coin":"DFiZY","lottieCoins":"GU4jB"};